import { Instance } from 'mobx-state-tree';
import moment from 'moment';
import getFormattedTime from '../../../helpers/getFormattedTime';
import { RouteConstraintDtoModelBase } from './RouteConstraintDtoModel.base';
import { RouteConstraintLocationDtoModelType } from './RouteConstraintLocationDtoModel';
import getAppRoot from '../utils/getAppRoot';

/* The TypeScript type of an instance of RouteConstraintDtoModel */
export interface RouteConstraintDtoModelType extends Instance<typeof RouteConstraintDtoModel.Type> {}

/* A graphql query fragment builders for RouteConstraintDtoModel */
export { selectFromRouteConstraintDto, routeConstraintDtoModelPrimitives, RouteConstraintDtoModelSelector } from './RouteConstraintDtoModel.base';

/**
 * RouteConstraintDtoModel
 */
export const RouteConstraintDtoModel = RouteConstraintDtoModelBase
  .views((self) => ({
    get startLocation(): RouteConstraintLocationDtoModelType {
      return self.startLocations?.slice()[0];
    },
    get endLocation(): RouteConstraintLocationDtoModelType | undefined {
      return self.endLocations?.slice()[0];
    },
    get isRoundTrip(): boolean {
      return this.startLocation.address === this.endLocation?.address;
    },
    get durationMinutes(): number | undefined | null {
      if (typeof self.duration === 'number') {
        return self.duration / 60;
      }
      return self.duration;
    },
    get startTimeString(): string | undefined {
      return getFormattedTime(moment(self.startTime), getAppRoot(self).organization.settings.dateTimeFormat);
    },
    get endTimeString(): string | undefined {
      return getFormattedTime(moment(self.endTime), getAppRoot(self).organization.settings.dateTimeFormat);
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
